import { render, staticRenderFns } from "./select-button.vue?vue&type=template&id=439c2e67&"
import script from "./select-button.vue?vue&type=script&lang=ts&"
export * from "./select-button.vue?vue&type=script&lang=ts&"
import style0 from "./select-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports